/**
 * @generated SignedSource<<b1e99bbe4520b191c19f745bc29a16b9>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type ExportFachberaterCertificatesInput = {
  clientMutationId?: string | null | undefined;
  contentNodeId: string;
  fromDateOpt?: string | null | undefined;
  toDateOpt?: string | null | undefined;
};
export type FachberaterCertificatesAndLettersExporter_ExportCertificatesMutation$variables = {
  input: ExportFachberaterCertificatesInput;
};
export type FachberaterCertificatesAndLettersExporter_ExportCertificatesMutation$data = {
  readonly Admin: {
    readonly Tree: {
      readonly exportFachberaterCertificates: {
        readonly clientMutationId: string | null | undefined;
      } | null | undefined;
    };
  };
};
export type FachberaterCertificatesAndLettersExporter_ExportCertificatesMutation = {
  response: FachberaterCertificatesAndLettersExporter_ExportCertificatesMutation$data;
  variables: FachberaterCertificatesAndLettersExporter_ExportCertificatesMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "AdminMutationType",
    "kind": "LinkedField",
    "name": "Admin",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "TreeAdminMutationSchema",
        "kind": "LinkedField",
        "name": "Tree",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": [
              {
                "kind": "Variable",
                "name": "input",
                "variableName": "input"
              }
            ],
            "concreteType": "ExportFachberaterCertificatesPayload",
            "kind": "LinkedField",
            "name": "exportFachberaterCertificates",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "clientMutationId",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "FachberaterCertificatesAndLettersExporter_ExportCertificatesMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FachberaterCertificatesAndLettersExporter_ExportCertificatesMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "a559185f7c9e986e891473c92e4c9080",
    "id": null,
    "metadata": {},
    "name": "FachberaterCertificatesAndLettersExporter_ExportCertificatesMutation",
    "operationKind": "mutation",
    "text": "mutation FachberaterCertificatesAndLettersExporter_ExportCertificatesMutation(\n  $input: ExportFachberaterCertificatesInput!\n) {\n  Admin {\n    Tree {\n      exportFachberaterCertificates(input: $input) {\n        clientMutationId\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "1cc063e70caa5c42e8586bfa7eefee99";

export default node;
